import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';
export const StyleServicesPage = styled.div`
  max-width: 1170px;
  width: 100%;
  scroll-margin-top: 130px;
  margin: 0 auto;
  .accordion-item:first-of-type,
  .accordion-item {
    margin-bottom: 10px;
    border-radius: 0px;
    border: 0px;
  }
  .accordion-button:focus {
    outline: 0px;
    box-shadow: none;
  }
  .accordion-button {
    background: #f4f4f4;
    outline: 0px;
    box-shadow: none;
    border-radius: 8px;
    font-weight: 600;
    color: #000;
  }
  .accordion-button::after {
    filter: invert(100%) grayscale(100%);
    background-color: rgb(115, 115, 115);
    border-radius: 50%;
    background-size: 70%;
    background-position: center;
  }
  .accordion-button:not(.collapsed)::after {
    filter: invert(100%) grayscale(100%);
    background-color: rgb(215, 195, 115);
    border-radius: 50%;
  }
  @media ${DEVICES.mobile} {
    width: 98%;
    margin: 0 auto;
  }
`;
